<h5 class="title mb-4 text-primary">{{'sessao_iii'|translate}}</h5>
<div class="row g-4 mb-4">
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_21')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_21="ngModel" name="mdc_21" [(ngModel)]="mdcService.formData.mdc_21"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc21options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_21_outro'], mdcService.formData.mdc_21! == 7, null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_21_outro="ngModel" name="mdc_21_outro"
                [(ngModel)]="mdcService.formData.mdc_21_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_22')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_22="ngModel" name="mdc_22" [(ngModel)]="mdcService.formData.mdc_22"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc22options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_22_outro'], mdcService.formData.mdc_22! == 4, null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_22_outro="ngModel" name="mdc_22_outro"
                [(ngModel)]="mdcService.formData.mdc_22_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_23'], mdcService.formData.mdc_22! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_23')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <input type="text" class="form-control form-control-sm" #mdc_23="ngModel" name="mdc_23"
                    [(ngModel)]="mdcService.formData.mdc_23" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                    required>
            </div>
        </div>
    </div>

    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_24'], mdcService.formData.mdc_22! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_24')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <ng-select #mdc_24="ngModel" name="mdc_24" id="mdc_24" [(ngModel)]="mdcService.formData.mdc_24"
                    [items]="mdcService.mdc24options" bindLabel="name" bindValue="id" (change)="onNgSelectChange()"
                    placeholder="{{'selct_msg'|translate}}" required>
                </ng-select>
                <input type="text" id="mdc_24_hidden" name="mdc_24_hidden" required
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" class="form-control form-control-sm"
                    style="opacity: 0; height: 0; position: absolute;" [value]="mdcService.formData.mdc_24">
                <!-- <span id="mdc_24_error_msg" *ngIf="mdcService.formData.mdc_24! == null"
                    class="text-danger ff-italic fs-11px">{{'obrigatorio_error_msg'|translate}}</span> -->
            </div>
            <div class="form-control-wrap mt-4"
                *ngIf="mdcService.isVisible(['mdc_24_outro'], mdcService.formData.mdc_24 == 0, null)">
                <input type="text" class="form-control form-control-sm" #mdc_24_outro="ngModel" name="mdc_24_outro"
                    [(ngModel)]="mdcService.formData.mdc_24_outro"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                    placeholder="{{'others_placeholder'|translate}}" required>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_25'], mdcService.formData.mdc_22! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_25')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <select class="form-select" #mdc_25="ngModel" name="mdc_25" [(ngModel)]="mdcService.formData.mdc_25"
                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                    <option value="">{{'selct_msg'|translate}}</option>
                    <option *ngFor="let item of mdcService.mdc25options" [value]="item.value">
                        {{item.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_25_outro'], mdcService.formData.mdc_25! == 5, null)">
        <div class="form-group">
            <input type="text" class="form-control form-control-sm" #mdc_25_outro="ngModel" name="mdc_25_outro"
                [(ngModel)]="mdcService.formData.mdc_25_outro" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                placeholder="{{'others_placeholder'|translate}}" required>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_26'], mdcService.formData.mdc_8! == 1 , null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_26')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <ul class="custom-control-group g-3 align-center flex-wrap">
                <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                    <div class="custom-control custom-checkbox custom-control-pro no-control">
                        <input type="radio" class="custom-control-input required" id="mdc_26_{{item.id}}"
                            [(ngModel)]="mdcService.formData.mdc_26" #mdc_26="ngModel" name="mdc_26"
                            value="{{item.value}}" [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                        <label class="custom-control-label" for="mdc_26_{{item.id}}">{{item.name}}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
    <div class="col-lg-12" *ngIf="mdcService.isVisible(['mdc_26_1'], mdcService.formData.mdc_26! == 1, null)">
        <div class="form-group">
            <label class="form-label mb-4">{{mdcService.getLabelByCode('mdc_26_1')}}<span
                    class="text-danger">&nbsp;*</span></label>
            <div class="form-control-wrap">
                <input type="text" class="form-control form-control-sm" #mdc_26_1="ngModel" name="mdc_26_1"
                    [(ngModel)]="mdcService.formData.mdc_26_1" [attr.data-msg]="('obrigatorio_error_msg' | translate)"
                    required>
            </div>
        </div>
    </div>
    <div class="col-lg-12">
        <div class="form-group">
            <label class="form-label">{{mdcService.getLabelByCode('mdc_27')}}</label>
            <div class="row g-3 mt-2">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_27_1')}}<span
                                class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_27_1_{{item.id}}"
                                    value="{{item.value}}" name="mdc_27_1" [(ngModel)]="mdcService.formData['mdc_27_1']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_27_1_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_27_2')}}<span
                                class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_27_2_{{item.id}}"
                                    value="{{item.value}}" name="mdc_27_2" [(ngModel)]="mdcService.formData['mdc_27_2']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_27_2_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row g-3 mt-2">
                <div class="col-lg-5 text-lg-end mt-0">
                    <div class="form-group">
                        <label class="form-label mb-4 mb-lg-2">{{mdcService.getLabelByCode('mdc_27_3')}}<span
                                class="text-danger">&nbsp;*</span></label>
                    </div>
                </div>
                <div class="col-lg-7 mt-0 mb-4 mb-lg-0">
                    <ul class="custom-control-group g-3 align-center flex-wrap">
                        <li *ngFor="let item of mdcService.mdcSimNaoOptions">
                            <div class="custom-control custom-radio">
                                <input type="radio" class="custom-control-input" id="mdc_27_3_{{item.id}}"
                                    value="{{item.value}}" name="mdc_27_3" [(ngModel)]="mdcService.formData['mdc_27_3']"
                                    [attr.data-msg]="('obrigatorio_error_msg' | translate)" required>
                                <label class="custom-control-label" for="mdc_27_3_{{item.id}}">{{item.name}}</label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>